import { IConfig } from "../types/IConfig";

export const projectName = 'CSM Shopfloor'
export const projectVersion = '0.0.3'

/**
 * Central accessor for the runtime config that `/config.aspx` injects into
 * `window.config` before React boots. Read LAZILY (at call time) rather than
 * captured at module scope in each service — that removes the import-order
 * coupling to the global shim and gives one seam that tests can mock.
 */
export const getConfig = (): IConfig => (window as unknown as { config: IConfig }).config;